import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { Partner } from '../../../partner/models/partner';
import { EventBookingCache } from '../../models/event-booking-cache';
import { BookingOrderService } from '../../services/booking-order.service';

@Component({
  selector: 'app-event-configurator',
  templateUrl: './event-configurator.component.html',
  styleUrls: ['./event-configurator.component.css']
})
export class EventConfiguratorComponent implements OnInit {

  @Input()
  personCount: number;

  @Input()
  minPersonCount: number;

  @Input()
  maxPersonCount: number;

  @Input()
  child: Partner;

  @ViewChild('slider', {static: true}) slider;

  private _eventBookingCache: EventBookingCache;

  constructor(
    protected bookingOrderService: BookingOrderService,
  ) {
  }

  ngOnInit() {
    this._eventBookingCache = this.bookingOrderService.eventCache;
  }

  partnerFormInvalid($event) {
    const partnerFormInvalidReasons = ['Please fill in all fields'];
    this._eventBookingCache.updateInvalidReason(partnerFormInvalidReasons);
  }

  partnerFormValid($event) {
    this._eventBookingCache.updateInvalidReason();
  }
}
